import "@escapio/shared/frame-buster";
import "@escapio/shared/components/ads/loader/Matomo";
import "@escapio/shared/components/ads/loader/Bing";
import "@escapio/shared/components/ads/loader/Facebook";
import "@escapio/shared/components/ads/loader/GoogleAdwords";
import "@escapio/shared/components/ads/loader/Pinterest";
import "@escapio/shared/components/Picture";
import "@escapio/portal/tracker/usercentrics/loader";
import "./components/ads/stroer/loader";
import "./components/travel-data/TravelTypeSelector";
import "./components/ClickTracker";
import "./components/ClickScroller";
import "./components/header/FavoritesLink";
import "./components/header/DealsLink";
import "./components/header/DropdownLanguages";
import "./components/header/DropdownCurrencies";
import "./components/main-menu/Burger";
import "./components/main-menu/Menu";
import "./components/newsletter/Banner";
import "./components/SearchPanelInputs";
import "./dom/detectDevice";
import "./state/utm";
import "./state/travelData";
import "./tracker/Experiments";
import "./admin-tools/loader";
import "./components/PrivacySettings";

import * as EventQueue from "./tracker/EventQueue";
EventQueue.fire();
